// List of major US cities with approximate lat/long and a search radius (meters)
// Radius chosen to encompass most urban area; adjust if needed.
export type CityTarget = {
  name: string;
  slug: string;
  lat?: number; // optional for name-based search fallback
  lng?: number; // optional for name-based search fallback
  radiusMeters?: number; // optional; text queries may not use radius
};

export const MAJOR_US_CITIES: CityTarget[] = [
  {
    name: "New York, NY",
    slug: "new-york-ny",
    lat: 40.7128,
    lng: -74.006,
    radiusMeters: 30000,
  },
  {
    name: "Los Angeles, CA",
    slug: "los-angeles-ca",
    lat: 34.0522,
    lng: -118.2437,
    radiusMeters: 30000,
  },
  {
    name: "Chicago, IL",
    slug: "chicago-il",
    lat: 41.8781,
    lng: -87.6298,
    radiusMeters: 25000,
  },
  {
    name: "Houston, TX",
    slug: "houston-tx",
    lat: 29.7604,
    lng: -95.3698,
    radiusMeters: 30000,
  },
  {
    name: "Phoenix, AZ",
    slug: "phoenix-az",
    lat: 33.4484,
    lng: -112.074,
    radiusMeters: 30000,
  },
  {
    name: "Philadelphia, PA",
    slug: "philadelphia-pa",
    lat: 39.9526,
    lng: -75.1652,
    radiusMeters: 25000,
  },
  {
    name: "San Antonio, TX",
    slug: "san-antonio-tx",
    lat: 29.4241,
    lng: -98.4936,
    radiusMeters: 30000,
  },
  {
    name: "San Diego, CA",
    slug: "san-diego-ca",
    lat: 32.7157,
    lng: -117.1611,
    radiusMeters: 25000,
  },
  {
    name: "Dallas, TX",
    slug: "dallas-tx",
    lat: 32.7767,
    lng: -96.797,
    radiusMeters: 25000,
  },
  {
    name: "San Jose, CA",
    slug: "san-jose-ca",
    lat: 37.3382,
    lng: -121.8863,
    radiusMeters: 25000,
  },
  {
    name: "Austin, TX",
    slug: "austin-tx",
    lat: 30.2672,
    lng: -97.7431,
    radiusMeters: 25000,
  },
  {
    name: "Jacksonville, FL",
    slug: "jacksonville-fl",
    lat: 30.3322,
    lng: -81.6557,
    radiusMeters: 30000,
  },
  {
    name: "Fort Worth, TX",
    slug: "fort-worth-tx",
    lat: 32.7555,
    lng: -97.3308,
    radiusMeters: 25000,
  },
  {
    name: "Columbus, OH",
    slug: "columbus-oh",
    lat: 39.9612,
    lng: -82.9988,
    radiusMeters: 25000,
  },
  {
    name: "Indianapolis, IN",
    slug: "indianapolis-in",
    lat: 39.7684,
    lng: -86.1581,
    radiusMeters: 25000,
  },
  {
    name: "Charlotte, NC",
    slug: "charlotte-nc",
    lat: 35.2271,
    lng: -80.8431,
    radiusMeters: 25000,
  },
  {
    name: "San Francisco, CA",
    slug: "san-francisco-ca",
    lat: 37.7749,
    lng: -122.4194,
    radiusMeters: 20000,
  },
  {
    name: "Seattle, WA",
    slug: "seattle-wa",
    lat: 47.6062,
    lng: -122.3321,
    radiusMeters: 25000,
  },
  {
    name: "Denver, CO",
    slug: "denver-co",
    lat: 39.7392,
    lng: -104.9903,
    radiusMeters: 25000,
  },
  {
    name: "Boston, MA",
    slug: "boston-ma",
    lat: 42.3601,
    lng: -71.0589,
    radiusMeters: 20000,
  },
];
